import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s — pleasant balance for accounting data
      gcTime: 5 * 60_000, // 5 min cache
      retry: (failureCount, error) => {
        // Don't retry 4xx — those are user/validation errors
        const status = (error as { status?: number })?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false, // accountants don't want surprise reloads
    },
    mutations: {
      retry: false,
    },
  },
});
